import React from "react";
import { handleKeyPress, handleKeyUp } from "../../ObjectPropertyBox/functions/PropertyBoxFunctions";
import { AnnotationPropType } from "../Annotation";
import HighlightAnnotation from "../hooks/HighlightAnnotation";

const AnnotationCircledLetter = (props: AnnotationPropType) => {
  const { annotation, count, ratio, index, kp, markSelected, objectIsInTimeline } = props;
  const alphas = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];
  const isDisplayed = typeof annotation.isDisplayed === "undefined" || annotation.isDisplayed;
  const opacity = objectIsInTimeline ? 1 : isDisplayed ? 1 : 0.5;

  const display = () => {
    return (
      <svg
        viewBox={`0 0 100 100`}
        key={index}
        id={`circledLetter-${index}`}
        tabIndex={0}
        name="circledLetter"
        className="annotation"
        onMouseDown={(e: React.MouseEvent<SVGSVGElement>) => markSelected(e.currentTarget, index, "annotations")}
        onKeyDown={(e: React.KeyboardEvent<SVGSVGElement>) => handleKeyPress(e, kp)}
        onKeyUp={(e: React.KeyboardEvent<SVGSVGElement>) => handleKeyUp(e, kp)}
        preserveAspectRatio="xMinYMin meet"
        opacity={opacity}
        style={{
          top: `${annotation.top}%`,
          left: `${annotation.left}%`,
          width: `${annotation.width}%`,
          height: `${annotation.height}%`,
          zIndex: annotation.zIndex,
          transform: `rotate(${annotation?.transform?.rotate ? annotation?.transform?.rotate : 0}deg)`,
        }}
      >
        <HighlightAnnotation annotation={annotation} />

        <circle
          cx="50"
          cy="50"
          r="47"
          stroke={`${annotation?.borderColor ? annotation?.borderColor : "transparent"}`}
          fill={`${annotation?.backgroundColor ? annotation.backgroundColor : "#4B4F58"}`}
          strokeWidth={`${annotation.strokeWidth || "3"}`}
        ></circle>
        <text
          className="step-text"
          x="50"
          y="50"
          dy="26.5"
          textAnchor="middle"
          fill={`${annotation?.fontColor ? annotation.fontColor : "white"}`}
        >
          {alphas[count - 1]}
        </text>
      </svg>
    );
  };

  return <React.Fragment>{display()}</React.Fragment>;
};

export default AnnotationCircledLetter;
